import { render, staticRenderFns } from "./protocol2.vue?vue&type=template&id=25023ad1"
import script from "./protocol2.vue?vue&type=script&lang=js"
export * from "./protocol2.vue?vue&type=script&lang=js"
import style0 from "./protocol2.vue?vue&type=style&index=0&id=25023ad1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports